export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-8">
          <div>
            <h3 className="text-2xl font-bold mb-4 bg-gradient-to-r from-yellow-400 to-pink-500 bg-clip-text text-transparent">
              TOP 40 STAR
            </h3>
            <p className="text-gray-300 mb-4">
              La lista musical adulta contemporánea más importante de España, 
              presentada por Alexis González.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors">
                <i className="ri-facebook-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-pink-600 rounded-full flex items-center justify-center hover:bg-pink-700 transition-colors">
                <i className="ri-instagram-line"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-red-600 rounded-full flex items-center justify-center hover:bg-red-700 transition-colors">
                <i className="ri-youtube-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-blue-400 rounded-full flex items-center justify-center hover:bg-blue-500 transition-colors">
                <i className="ri-twitter-fill"></i>
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Información</h4>
            <ul className="space-y-2 text-gray-300">
              <li className="flex items-center gap-2">
                <i className="ri-calendar-line"></i>
                <span>Actualización: Cada Sábado</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line"></i>
                <span>Horario: 10:00 - 13:00</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-radio-line"></i>
                <span>Radio 2050 España</span>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2024 TOP 40 STAR España. Todos los derechos reservados.</p>
          <p className="mt-2">
            <a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors">
              Powered by Readdy
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}